import SDIcon from '../SDIcon'
import type { SDIconProps } from '../SDIcon'

const IconWindowExpand = ({ size = 16, color = 'currentColor', ...props }: SDIconProps) => (
  <SDIcon viewBox='0 0 24 24' size={size} color={color} aria-hidden='true' {...props}>
    <g fill='none' stroke='currentColor' strokeWidth='1.9' strokeLinecap='round' strokeLinejoin='round'>
      <path d='M14 10l6-6' />
      <path d='M15 4h5v5' />
      <path d='M10 14l-6 6' />
      <path d='M4 15v5h5' />
    </g>
  </SDIcon>
)

export default IconWindowExpand
